// $(document).ready(function(){
// const videos = [
//     { id: "video1", buttonId: "circle-play-b1" },
//     { id: "video2", buttonId: "circle-play-b2" },
//     { id: "video3", buttonId: "circle-play-b3" }
// ];

// videos.forEach((videoData, index) => {
//     const video = document.getElementById(videoData.id);
//     const circlePlayButton = document.getElementById(videoData.buttonId);

//     function togglePlay(e) {
//         e.preventDefault();
//         videos.forEach((v, i) => {
//             if (i !== index) {
//                 document.getElementById(v.id).pause();
//                 document.getElementById(v.buttonId).style.opacity = 1;
//             }
//         });

//         if (video.paused || video.ended) {
//             video.play();
//         } else {
//             video.pause();
//         }
//     }

//     circlePlayButton.addEventListener("click", togglePlay);

//     video.addEventListener("playing", function () {
//         circlePlayButton.style.opacity = 0;
//     });
//     video.addEventListener("pause", function () {
//         circlePlayButton.style.opacity = 1;
//     });
//   });
// });

$(document).ready(function(){
  const video = document.getElementById("video1");
  const circlePlayButton = document.getElementById("circle-play-b1");

  function togglePlay(e) {
      e.preventDefault()
      if (video.paused || video.ended) {
            video.play();
      } else {
          video.pause();
      }
  }
  if (circlePlayButton) {
  circlePlayButton.addEventListener("click", togglePlay);
  }

  video.addEventListener("playing", function () {
    circlePlayButton.style.opacity = 0;
  });
  video.addEventListener("pause", function () {
    circlePlayButton.style.opacity = 1;
  });
});
  


$('.BannerSlide').owlCarousel({
         loop:true,
//          margin:24,
         autoplay:true,
         autoplayTimeout:20000,smartSpeed:600,
         nav:true,
         responsive:{
         0:{
           items:1
         },
         600:{
           items:1
         },
         1000:{
           items:1
         }
         }, navText: ['']
         });


$('.media-slider').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
  autoplay: true,
  autoPlaySpeed: 5000,
    dots:false,
    responsive:{
        0:{
            items:2
        },
        600:{
            items:3
        },
        1000:{
            items:5
        }
    }
})

// fancy-box-js-start
  $('[data-fancybox="gallery"]').fancybox({
	  buttons: [
	    "slideShow",
	    "thumbs",
	    "zoom",
	    "fullScreen",
	    "share",
	    "close"
	  ],
	  loop: false,
	  protect: true
	});
// fancy-box-js-end

// scroll js comparision section
 var setInvisible = function(elem) {
    elem.css('visibility', 'hidden');
  };
  var setVisible = function(elem) {
    elem.css('visibility', 'visible');
  };
  var outer = $('.product-comparison-table.table-responsive');
if (outer === "undefined") {
  var outer_width = outer.width();
  var outer_widthWithScroll = outer[0].scrollWidth;
  
      console.log(outer)
  var scrolling_width = outer_widthWithScroll - outer_width;
  
    if(outer_widthWithScroll == outer_width ) {
      setInvisible($('.swatches_prev'));
      setInvisible($('.swatches_next'));
    }else{
      console.log('width is not define')
    }
}
  
  $(document).on('click','.swatches_next',function() {
     var leftPos = outer.scrollLeft();
     outer.animate({
       scrollLeft: leftPos + 400
     }, 500);
    setTimeout(function () {
      leftPos = outer.scrollLeft();
      if(leftPos < 1 ) {
        setVisible($('.swatches_next'));
        setInvisible($('.swatches_prev'));
      }else if(leftPos > 1 && leftPos == scrolling_width){
        setVisible($('.swatches_prev'));
        setInvisible($('.swatches_next'));
      }else if(leftPos > 1) {
        setVisible($('.swatches_prev'));
      }
    }, 600);
   });

   $(document).on('click','.swatches_prev',function() {
     var leftPos = outer.scrollLeft();
     outer.animate({
       scrollLeft: leftPos - 200
     }, 500);
    setTimeout(function () {
      leftPos = outer.scrollLeft();
      if(leftPos < 1) {
        setVisible($('.swatches_next'));
        setInvisible($('.swatches_prev'));
      }else if(leftPos > 1){
        setVisible($('.swatches_next'));
      }
    }, 600);
   });

 
// accordion
 $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
 $(e.target)
   .prev()
   .find("i:last-child")
   .toggleClass("fa-minus fa-plus");
});

// accordion
$(window).scroll(function(){
        if ($(this).scrollTop() > 70) {
            $('header').addClass('sticky-header');
        } else {
            $('header').removeClass('sticky-header');
        }
    });

// for sorting on home page products best seller
  $(document).ready(function(){
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
};
$('#meun-items-2')
  .val('')
  .bind('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });
  }); 

// for filter on home-page products best-sellers
  $(document).ready(function() {
    const products = $(".item");

    function populateSelectBox(selectBox, values) {
      $.each(values, function(index, value) {
        selectBox.append($("<option>").text(value).val(value));
      });
    }

    function getUniqueValues(array) {
      return $.unique(array);
    }

    const categories = getUniqueValues(products.map(function() {
      return $(this).data("category");
    }).get());

    const types = getUniqueValues(products.map(function() {
      return $(this).data("type");
    }).get());

    const tags = getUniqueValues(products.map(function() {
      return $(this).data("tags");
    }).get());

    populateSelectBox($("#menu-items"), ["All", ...categories]);
    populateSelectBox($("#menu-items-2"), ["All", ...types]);
    populateSelectBox($("#menu-items-3"), ["All", ...tags]);

    $(".filter-box").change(function() {
      const selectedCategory = $("#menu-items").val();
      const selectedType = $("#menu-items-2").val();
      const selectedTags = $("#menu-items-3").val();

      products.each(function() {
        const category = $(this).data("category");
        const type = $(this).data("type");
        const tags = $(this).data("tags");

        if ((selectedCategory === "All" || selectedCategory === category) && 
            (selectedType === "All" || selectedType === type) && 
            (selectedTags === "All" || selectedTags === tags)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    });
  });

// for video changes on accordian

  $(document).ready(function(){
      $('.accordion-button').click(function(){
            // Get the index of the clicked accordion
            var index = $(this).closest('.accordion-item').index();
           
            // Define video sources corresponding to each accordion index
            var videoSources = [
                "https://cdn.shopify.com/videos/c/o/v/f270a82c95744a63bd02af2a5d7dd5bc.mp4",
                "https://cdn.shopify.com/videos/c/o/v/640da9fe3c004e7bb560dc1832a97ef9.mp4", 
                "https://cdn.shopify.com/videos/c/o/v/af405de612854f8e8e95f30c6d163fb3.mp4",
                "https://cdn.shopify.com/videos/c/o/v/8d1951c9467643668b6439b4fbf75ce6.mp4"  
            ];
         console.log(index, videoSources[index])
            // Change the video source based on the index
            $('#videoSource').attr('src', videoSources[index]);
            // Reload the video
          $('#VideoTag').get(0).load()
          $('#VideoTag').get(0).play()
        });
    });


// For header js

$(document).ready(function(){
    $(".main-header ul li i").click(function(){
       $(".dropdown-nav").toggle(); 
       $(this).parent('.main-header ul li').toggleClass('rotateshow')
    });
});


$('.navbar-toggler').click(function(){
    $(this).toggleClass('navbar-closed')

 })





$('.banner-slider').owlCarousel({
    items:0,
    loop:false,
    margin:0,
    dots:false,
    navText: ["<i class='fa-solid fa-arrow-left'></i>","<i class='fa-solid fa-arrow-right'></i>"],
    nav:true,
    responsive:{
        0:{
            items:1,
            loop:false,
        },
        600:{
            items:1,
            loop:false,
        },
        992:{
            items:1
        },
        1000:{
            items:1
        }
    }
});

$('.product-slider').owlCarousel({
    loop:true,
    margin:20,
    dots:false,
    navText: ["<i class='fa-solid fa-arrow-left'></i>","<i class='fa-solid fa-arrow-right'></i>"],
    nav:true,
     // dotEach:true,
     responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
       768:{
            item:3
        },
        992:{
            items:3
        },
        1000:{
            items:4
        }
    }
  
})

if($(window).width() < 767) {
  $('.shaker-all-grid-slider').slick({
    infinite: true,
    slidesToShow:2,
    slidesToScroll: 1,
    pauseOnHover:false, 
    autoplay: true,
    autoplaySpeed: 2500,
    arrows:false
  });
}

if($(window).width() < 767) {
  $('.features_slider').slick({
    infinite: true,
    slidesToShow:2,
    slidesToScroll: 1,
    pauseOnHover:false, 
    autoplay: true,
    autoplaySpeed: 2500,
    arrows:false
  });
}

$('.Protein-shake-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover:false,
  adaptiveHeight: true,
  draggable: false,
  swipeToSlide: false,
  touchMove: false,
  swipe: false,
  accessibility: false,
  // autoplay: true,
  autoplaySpeed: 2500,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa-solid fa-arrow-left'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa-solid fa-arrow-right'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow:1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow:1
      }
    },
    {
      breakpoint: 0,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    ]
});

const slider = document.getElementById('before-after-slider');
const before = document.getElementById('before-image');
const resizer = document.getElementById('resizer');

let active = false;

//Sort overflow out for Overlay Image
if(before) {
  const beforeImage = before.getElementsByTagName('img')[0];
  document.addEventListener("DOMContentLoaded", function() {
    let width = slider.offsetWidth;
    // console.log(width);
    beforeImage.style.width = width + 'px';
  });
  
  //Adjust width of image on resize 
  window.addEventListener('resize', function() {
    let width = slider.offsetWidth;
    // console.log(width);
    beforeImage.style.width = width + 'px';
  })
}
if(resizer) {
  resizer.addEventListener('mousedown',function(){
    active = true;
   resizer.classList.add('resize');
  
  });
  
  document.body.addEventListener('mouseup',function(){
    active = false;
   resizer.classList.remove('resize');
  });
  
  document.body.addEventListener('mouseleave', function() {
    active = false;
    resizer.classList.remove('resize');
  });
  
  document.body.addEventListener('mousemove',function(e){
    if (!active) return;
    let x = e.pageX;
    x -= slider.getBoundingClientRect().left;
    slideIt(x);
    pauseEvent(e);
  });
  
  resizer.addEventListener('touchstart',function(){
    active = true;
    resizer.classList.add('resize');
  });
  
  document.body.addEventListener('touchend',function(){
    active = false;
    resizer.classList.remove('resize');
  });
  
  document.body.addEventListener('touchcancel',function(){
    active = false;
    resizer.classList.remove('resize');
  });
  
  //calculation for dragging on touch devices
  document.body.addEventListener('touchmove',function(e){
    if (!active) return;
    let x;
    
    let i;
    for (i=0; i < e.changedTouches.length; i++) {
    x = e.changedTouches[i].pageX; 
    }
    
    x -= slider.getBoundingClientRect().left;
    slideIt(x);
    pauseEvent(e);
  });
  
  function slideIt(x){
      let transform = Math.max(0,(Math.min(x,slider.offsetWidth)));
      before.style.width = transform+"px";
      resizer.style.left = transform-0+"px";
  }
  
  //stop divs being selected.
  function pauseEvent(e){
      if(e.stopPropagation) e.stopPropagation();
      if(e.preventDefault) e.preventDefault();
      e.cancelBubble=true;
      e.returnValue=false;
      return false;
  }
}


// partner-slider
$('.partner-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
   prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa-solid fa-arrow-left'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa-solid fa-arrow-right'></i></button>",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
          slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ]
});
// =======================
$('.testimonail-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:false,
  adaptiveHeight: true,
   prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa-solid fa-arrow-left'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa-solid fa-arrow-right'></i></button>",
});
// =================



$('.why-section-slider').slick({
  infinite:false,
  slidesToShow: 1,
  slidesToScroll: 1,
   prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa-solid fa-arrow-left'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa-solid fa-arrow-right'></i></button>",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
          slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ]
});

$('.why-section-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    console.log('Current Slide:', currentSlide);
    console.log('Total Slides:', slick.slideCount);
      if(currentSlide == 0) {
        $('why-section-slider .slick-prev').css("display", "none"); // Hides previous arrow on first slide
        $('.slick-prev').addClass("hidden");
      } else {
        $('why-section-slider .slick-prev').css("display", "block"); // Shows previous arrow on other slides
          $('.slick-prev').removeClass("hidden");
      }

      if(currentSlide == 5) {
        $('why-section-slider .slick-next').css("display", "none"); // Hides next arrow on last slide
          $('.slick-next').addClass("hidden");
      } else {
        $('why-section-slider .slick-next').css("display", "block"); // Shows next arrow on other slides
        $('.slick-next').removeClass("hidden");
      }
    });

$(document).ready(function(){
  $(".more_description").click(function(e){
    e.preventDefault();
    console.log($(this).text())
    $(".prdDesc").toggleClass('active_desc');
    $(this).text(function(i, text){
      return text === "read more" ? "read less" : "read more";
    });
    if($(this).text() == "read more"){
      if($(window).width() > 767){
        $('body, html').animate({
          scrollTop: $(".Protein-shaker-section").offset().top
        }, 100);
      }else {
        $('body, html').animate({
          scrollTop: $(".product__slider-thmb").offset().top
        }, 100);
      }
    }
  });
});
// ==============================



// For products swathces slider 

$(document).on('click','.product-color-image', function(e){
  e.preventDefault();
  // console.log(item)
  // Get the product ID from the data-product-id attribute
  var item = $(this);
  const productId = item.attr('data-product-id');
  
  // Use the Fetch API to get the product data
  fetch(`/products/${productId}`)
    .then(response => response.json())
    .then(data => {
     // Find the parent element with the active class
      const activeCard = item.parents('.Protein-shake-card');
        // console.log(activeCard, data)
      // Update the product title for the active card
      if (activeCard) {
        const myImages = data.images
        // console.log(data.images)
        const titleElement = activeCard.find('.shake-heading');
        const descElement = activeCard.find('.prdDesc');
        const priceElement = activeCard.find('.prdPrice');
        const imageContainer = activeCard.find('.single-product');
        const imageThumb = activeCard.find('.thumb-product');
        const CartForm = activeCard.find('.direct-add-to-cart input');
        const CtnBtn = activeCard.find('.moreless-button ');
        const prdURL = activeCard.find('.prdURL');

      // for read more and read less
        // CtnBtn.text('Read More');
        // descElement.addClass('expand_content');
        
      console.log(CartForm)
        if (titleElement, descElement) {
          $(titleElement).text(data.title);
          $(descElement).html(data.description); 
          $(prdURL).attr('href', data.url)
          let result = data.variants
          
           result.map(a => {
             CartForm.attr("value", a.id ) 
             // console.log(CartForm, a.id )
           });
  
          
        }
        imageContainer.slick('unslick');
        imageThumb.slick('unslick');
        setTimeout(function () {
          imageContainer.empty();
          imageThumb.empty();
          myImages.forEach(function(images){
            let box = '<div class="single-product-item">  <div class="single-product-image"> <img src="' +  images + '" class="img-fluid"> </div> </div>';
            imageContainer.append(box);
          })
          myImages.forEach(function(images){
            let box = '<div class="thumbs-item"> <div class="single-products-image"> <img src="' +  images + '" class="img-fluid">  </div> </div>';
            imageThumb.append(box);
          })
          imageContainer.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            fade: true,
            infinite:false,
            asNavFor: imageThumb
          });
          imageThumb.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: imageContainer,
            dots: false,
            arrows: false,
            infinite:false,
            focusOnSelect: true,
          });
        }, 500);
        
      }
      // Handle the product data as needed
    })
    .catch(error => {
      console.error('Error fetching product data:', error);
    });
  });

// ========================
if ( $('.product__slider-main').length ) {
    var $slider = $('.product__slider-main')
        .on('init', function(slick) {
            $('.product__slider-main').fadeIn(1000);
        })
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite:false,
            arrows: true,
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa-solid fa-arrow-right'></i></button>",
            lazyLoad: 'ondemand',
            autoplaySpeed: 3000,
            asNavFor: '.product__slider-thmb'
        });
  
      var $slider2 = $('.product__slider-thmb')
              .on('init', function(slick) {
                  $('.product__slider-thmb').fadeIn(1000);
              })
              .slick({
                  slidesToShow:5,
                  slidesToScroll: 1,
                  infinite:false,
                  lazyLoad: 'ondemand',
                  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa-solid fa-arrow-right'></i></button>",
                  asNavFor: '.product__slider-main',
                  dots: false,
                  centerMode: false,
                  focusOnSelect: true
              });
  
         //remove active class from all thumbnail slides
         $('.product__slider-thmb .slick-slide').removeClass('slick-active');
        
         //set active class to first thumbnail slides
         $('.product__slider-thmb .slick-slide').eq(0).addClass('slick-active');
        
         // On before slide change match active thumbnail to current slide
         $('.product__slider-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
         	var mySlideNumber = nextSlide;
         	$('.product__slider-thmb .slick-slide').removeClass('slick-active');
         	$('.product__slider-thmb .slick-slide').eq(mySlideNumber).addClass('slick-active');
        });
    
    
    // init slider
  require(['js-sliderWithProgressbar'], function(slider) {
  
      $('.product__slider-main').each(function() {
  
          me.slider = new slider($(this), options, sliderOptions, previewSliderOptions);
  
          // stop slider
          //me.slider.stop();
  
          // start slider
          //me.slider.start(index);
  
          // get reference to slick slider
          //me.slider.getSlick();
  
      });
  });
    var options = {
      progressbarSelector    : '.bJS_progressbar'
      , slideSelector        : '.bJS_slider'
      , previewSlideSelector : '.bJS_previewSlider'
      , progressInterval     : ''
          // add your own progressbar animation function to sync it i.e. with a video
          // function will be called if the current preview slider item (".b_previewItem") has the data-customprogressbar="true" property set
      , onCustomProgressbar : function($slide, $progressbar) {}
  }
  
      // slick slider options
      // see: https://kenwheeler.github.io/slick/
  var sliderOptions = {
      slidesToShow   : 1,
      slidesToScroll : 1,
      arrows         : false,
      fade           : true,
      autoplay       : true
  }
  
      // slick slider options
      // see: https://kenwheeler.github.io/slick/
  var previewSliderOptions = {
      slidesToShow   : 3,
      slidesToScroll : 1,
      dots           : false,
      focusOnSelect  : true,
      centerMode     : true
  }
}
// ========================

$(document).on('change', '#FacetFiltersForm', function () {
  $(this).submit();
}); 
$('.a-dropdown__select').on('change', function(){
 window.location = $(this).val();
});
$(document).on("click",function(event){
  if(!$(event.target).closest("#wapper").length) {
    $('div.a-dropdown').removeClass('-isOpened');
    $('div.a-dropdown .a-dropdown__items').addClass('--hidden');
  }
});